import { ITypedReduxAction } from '../../types/redux/actionType';
import { INewBuilding, INewbuildingsStore } from '../../types/newBuldings';
import { IFilters } from '../../types/filters';
import { TThunkAction } from '../../types/redux/thunk';
import { getNewBuildings } from '../../services';
import { getRoomsRange, normalizeData, Typify } from '../../utils';
import { checkFsk } from '../../selectors';

export enum ENewBuildingsTypes {
  NewBuildingsChange = 'NEW_BUILDINGS/CHANGE_DATA',
}

export type TNewBuildingsChange = ITypedReduxAction<ENewBuildingsTypes, INewbuildingsStore>;

export function newBuildingsChange(filters: IFilters): TThunkAction<Promise<void>> {
  return async (dispatch, getState, { httpApi, logger }) => {
    try {
      const store = getState();
      const isFsk = checkFsk(store);
      const rooms = getRoomsRange(filters.rooms);
      const response = await getNewBuildings({
        httpApi,
        subdomain: 'www',
        parameters: {
          fromDeveloperOnly: isFsk,
          developerId: filters.developerId,
          newbuildingStatus: filters.newbuildingStatus,
          regionId: filters.regionId,
          minPrice: filters.minPrice,
          maxPrice: filters.maxPrice,
          rooms,
          maxArea: filters.maxArea,
          minArea: filters.minArea,
        },
      });

      const normalizedNewBuildings = normalizeData<Typify<INewBuilding>>(response.newbuildings);

      dispatch({
        type: ENewBuildingsTypes.NewBuildingsChange,
        payload: { data: normalizedNewBuildings, tabs: response.newbuildingCounts, jsonQuery: response.jsonQuery },
      });
    } catch (error) {
      logger.error(error, {
        domain: 'getNewBuildings',
      });
    }
  };
}
